import { classifyCaptureError, VoiceRecordingError } from '../../hooks/useVoiceRecording'

/** Echo cancellation keeps the speakers (Arc, the room) out of the mic. */
const MIC_PROCESSING = { echoCancellation: true, noiseSuppression: true, autoGainControl: true }

interface IOpenMicrophoneOptions {
  /** The chosen input; the default when null or unplugged. */
  deviceId?: string | null
  /** What to tell the person for each way capture can fail. */
  messages: Record<VoiceRecordingError, string>
}

export const openMicrophone = async ({
  deviceId,
  messages,
}: IOpenMicrophoneOptions): Promise<MediaStream> => {
  try {
    if (deviceId) {
      try {
        return await navigator.mediaDevices.getUserMedia({
          audio: { ...MIC_PROCESSING, deviceId: { exact: deviceId } },
        })
      } catch (err) {
        if ((err as Error)?.name !== 'OverconstrainedError') throw err
      }
    }
    return await navigator.mediaDevices.getUserMedia({ audio: MIC_PROCESSING })
  } catch (err) {
    throw new Error(messages[classifyCaptureError(err)], { cause: err })
  }
}
